import { CustomWidthHeightProps } from './interfaces/utils';

export const createNewWidthHeightStyle = (props: CustomWidthHeightProps) => {
  const { width, height } = props;
  const result: CustomWidthHeightProps = {};
  if (width) {
    result.width = width;
  }
  if (height) {
    result.height = height;
  }
  return result;
};

export const getCSSVariable = (variable: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(variable);

export const separateNumber = (value: number | string) => {
  const list = value.toString().split('');
  const length = list.length;
  return list
    .map((item, index) => {
      const isSeparate = (length - index) % 3 === 0;
      if (isSeparate) {
        return ' ' + item;
      }
      return item;
    })
    .join('');
};
